export const MIXPANEL_EVENTS = {
    // Search events
    CLICKED_SEARCH_BAR: 'LOHP - Clicked Search Bar',
    SUBMITTED_SEARCH: 'LOHP - Submitted Search',
    CLICKED_POPULAR_SEARCH_TAG: 'LOHP - Clicked Popular Search Tag',

    // Popular Services (Categories) events
    CLICKED_CATALOG_SERVICE_BUTTON: 'LOHP - Clicked Catalog Service Button',
    CLICKED_POPULAR_SERVICES_TAGS: 'LOHP - Clicked Popular Services Tags',

    // UGC/Testimonials events
    CLICKED_UGC_VIDEO: 'LOHP - Clicked UGC Video',
    CLICKED_UGC_POPUP_CTA: 'LOHP - Clicked UGC Popup CTA',
    CLICKED_UGC_POPUP_SELLER: 'LOHP - Clicked UGC Popup Seller',
    TESTIMONIALS_IS_SHOWN: 'LOHP - Testimonials is Shown',

    // Pro Section events
    CLICKED_PREMIUM_SERVICE: 'LOHP - Clicked Pro USPs',
    CLICKED_PRO_CTA: 'LOHP - Clicked Pro CTA',

    // CTA events
    CLICKED_CTA_BUTTON: 'LOHP - Clicked CTA Button',

    // FAQs events
    CLICKED_FAQ_ITEM: 'LOHP - Clicked FAQ Item',

    // Page view events
    BRAND_PAGE_VIEW: 'LOHP - Brand Page View',
    BRAND_MOTION_IS_TRIGGERED: 'LOHP - Brand Motion is Triggered',
} as const;
